require("./adverts.scss");
require("./legacy-ads.scss");

(function ($) {
    function resize() {
        const ad = $(".adverts-sidebar");
        if ($(window).height() < 768 && ad.height() > 600)
            ad.addClass("small-screen");
        else
            ad.removeClass("small-screen");
    }
    resize();
    
    const adResize = new ResizeObserver(entries => {
      entries.forEach(entry => {
       if (entry.contentRect.height > 50 ) 
          $('.ad-unit-top-leaderboard').addClass('ad-loaded') 
        else 
          $('.ad-unit-top-leaderboard').removeClass('ad-loaded');
      });
    });
    
    const adWrapper = document.querySelector('.ad-unit-top-leaderboard');
    if (adWrapper) adResize.observe(adWrapper);

    $(window).on("load scroll resize", resize);

    // duplicated mm code
    const rMin = 1000000000, rMax = 9999999999;
    const getRandomNumber = () => Math.floor(Math.random() * (rMax - rMin + 1) + rMin);
    const getViewId = () => (global.mm_advert_view_id = global.mm_advert_view_id || getRandomNumber());

    const getOtherTags = (tile) => [
        { key: "tile", value: tile },
        { key: "viewid", value: getViewId() },
        { key: "random", value: getRandomNumber() }
    ];

    const getKruxTags = () => {
        var kruxSasHelper = window.KruxSasHelper;
        if (kruxSasHelper) {
            return [
                { key: "", value: kruxSasHelper().getSasTags() },
                { key: "", value: kruxSasHelper().getGaTags() }
            ];
        }

        console.warn("KruxSasHelper not loaded");
        return [];
    };

    const getReplaceTags = (elm) => {
        var dataset = $(elm).data();
        return Object.keys(dataset)
            .filter(k => k.startsWith("adReplace"))
            .map(k => ({ key: k.replace("adReplace", "").toLowerCase(), value: dataset[k] }));
    };

    const getTags = (elm, tile) => [ ...getOtherTags(tile), ...getKruxTags(), ...getReplaceTags(elm) ];

    const replaceTags = (url, tags) => {
        const cleanSlashes = val => String(val).split("/").filter(x => x).join("/");

        tags.filter(x => x.value !== "")
            .forEach(tag => {
                if (tag.key === "") {
                    url = `${cleanSlashes(url)}/${cleanSlashes(tag.value)}`;
                } else {
                    url = url.replace(new RegExp(`${tag.key}=.*?(\/|$)`, "gmi"), "");
                    url = `${cleanSlashes(url)}/${tag.key}=${cleanSlashes(tag.value)}`;
                }
            });

        return url;
    };

    const loadAdvert = (elm, tile) => new Promise((resolve, reject) => {
        var scriptUrl = window.media_motive_ad_script_url;
        if (!scriptUrl) throw new Error("scriptUrl is not defined");

        const tags = getTags(elm, tile);
        var url = replaceTags(scriptUrl.split("//").slice(1).join("//"), tags);
        url = scriptUrl.split("//")[0] + "//" + url;

        console.log(`loading ${tile} at ${url}`);

        elm.empty();
        postscribe(elm, `<script src="${url}"></script>`,
            {
                done: () => {
                    elm.css("background", "none");
                    resolve();
                },
                error: (err) => {
                    elm.empty();
                    reject({ url: url, error: err });
                }
            });
    });

    // 'lazy' load ads as they are scrolled to view
    const isAboveScreenBottom = (el, viewportTop) => {
        var elementTop = $(el).offset().top;
        var viewportBottom = viewportTop + window.innerHeight;

        return elementTop < viewportBottom;
    }

    var unloadedAds = [...document.querySelectorAll("div[data-ad-lazy-tile]")]
        .filter(ad => String(ad.dataset.adSkipOnLoad).toLowerCase() !== "true");

    function loadOnScreenAds() {
        var windowTop = $(window).scrollTop();
        unloadedAds.filter(ad => isAboveScreenBottom(ad, windowTop))
            .forEach(ad => {
                loadAdvert($(ad), ad.dataset.adLazyTile)
                    .catch(e => console.log("MM: Error loading advert", e));
                unloadedAds.splice(unloadedAds.indexOf(ad), 1);
            });

        if (!unloadedAds.length) document.removeEventListener("scroll", loadOnScreenAds);
    }

    loadOnScreenAds();
    document.addEventListener("scroll", loadOnScreenAds);

})(jQuery);
